import { AppService } from 'app/services/app.service';
import { AppFilter } from 'app/models/app-filter.model';

export abstract class AbAdminRecado extends AppService {
  abstract getAllRecadosInicio(filter: AppFilter);
}
